module.exports = __webpack_public_path__ + "static/tecnicos-5.e6db1723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/tecnicos-5.jpg
// module id = 164
// module chunks = 48515692054781 177461795657893